"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEventListener = void 0;

var _react = require("react");

/**
 * @name useEventListener
 * @description A custom hook for simplicity using event listeners on window
 * @param {string} eventName Event name, which should be listen
 * @param {(event:Event|CustomEvent)} handler Callback, will be called when event happens.
 * @returns void
 */
var useEventListener = function useEventListener(eventName, handler) {
  // Create a ref that stores handler
  var savedHandler = (0, _react.useRef)(handler);
  (0, _react.useEffect)(function () {
    savedHandler.current = handler;
  }, [handler]);
  (0, _react.useEffect)(function () {
    // Create event listener that calls handler function stored in ref
    var eventListener = function eventListener(event) {
      return savedHandler.current(event);
    };

    window.addEventListener(eventName, eventListener); // Remove event listener on cleanup

    return function () {
      window.removeEventListener(eventName, eventListener);
    };
  }, [eventName]);
};

exports.useEventListener = useEventListener;